import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogGrid from "@/shared/ui/SogGrid.vue";
import {computed, onMounted, ref, watch} from "vue";
import {Api} from "@/shared/services/api";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {BooleanColumn, DateColumn, DateTimeColumn} from "@/shared/ui/types/SogGridColumnDefinitions";
import BordereauPeriod from "@/shared/model/BordereauPeriod";


interface Props {
  bordereauId?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'BordereauListComponent',
  props: {
    bordereauId: { default: undefined }
  },
  emits: ["selected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props


const _grid = ref<InstanceType<typeof SogGrid> | null>(null)
const _url = Api.baseUrl + '/BordereauPeriodList';
const _columns: ColumnModel[] = [
  {...DateColumn, field: 'periodFrom', headerText: 'Periode von', visible: true},
  {...DateColumn, field: 'periodTill', headerText: 'Periode bis', visible: true},
  {...DateTimeColumn, field: 'closedDate', headerText: 'Abschlussdatum', visible: true},
  {...DateTimeColumn, field: 'uploadedDate', headerText: 'Hochgeladen', visible: true},
  {...BooleanColumn, field: 'isCurrent', headerText: 'Ist Aktuell', visible: true},
]
const _adaptor = computed(() => {
  return _grid?.value?.adaptor
})

const _emit = __emit

function onRowSelected(args: any) {
  _emit("selected", args.data)
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _emit("selected", undefined)
}

function refresh() {
  _grid.value?.refresh()
}

function p_refresh() {
  _adaptor.value?.removePredicate("bordereauId");
  _adaptor.value?.addPredicate("bordereauId", "equal", props.bordereauId ?? "");
  refresh();
}

watch(props, () => {
    p_refresh();
  }
)

onMounted(() => {
    p_refresh()
  }
)

__expose({
  refresh
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogGrid, {
    ref_key: "_grid",
    ref: _grid,
    url: _url,
    columns: _columns,
    width: "auto",
    "on-row-selected": onRowSelected,
    "on-row-deselected": onRowDeselected
  }, null, 512))
}
}

})